import React, { useState } from "react";
import api, { getCurrentUser } from "../api";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const [showPwd, setShowPwd] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await api.post("/auth/login", {
        email,
        password: pwd,
      });

      const token = res.data?.access_token;
      if (!token) throw new Error("Access token missing");

      // ✅ USE ORIGINAL KEY (VERY IMPORTANT)
      localStorage.setItem("token", token);

      // Small delay to ensure storage sync
      await new Promise((r) => setTimeout(r, 50));

      const user = getCurrentUser();
      if (!user || !user.role) {
        localStorage.removeItem("token");
        throw new Error("Invalid login token");
      }

      localStorage.setItem("role", user.role);

      // ===== ROLE BASED REDIRECT =====

      if (user.role === "super_admin") {
        nav("/admin/dashboard");
        return;
      }

      if (user.role === "management") {
        nav("/management/dashboard");
        return;
      }

      if (user.role === "user" || user.role === "student") {
        try {
          const subRes = await api.get("/subscription/my");
          if (subRes.data?.has_subscription === true) {
            nav("/user/dashboard");
          } else {
            nav("/subscription");
          }
        } catch {
          nav("/subscription");
        }
        return;
      }

      nav("/login");

    } catch (err) {
      alert(
        err?.response?.data?.msg ||
        err?.message ||
        "Login failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardWrapper}>
          <img src="/logo.png" alt="EduAt10" style={logoStyle} />

          <form onSubmit={submit} style={cardStyle}>
            <h2 style={titleStyle}>Welcome Back 👋</h2>
            <p style={subtitleStyle}>
              Login to continue your learning journey
            </p>
            <p>&nbsp;</p>
            <p>
              EduAt10 एक शिक्षा-केंद्रित डिजिटल लर्निंग प्लेटफॉर्म है, जिसे उन छात्रों
              के लिए बनाया गया है जो महंगी ट्यूशन फीस या किताबें खरीदने में सक्षम नहीं
              हैं।
              हमारा उद्देश्य न्यूनतम लागत पर विषयवार अध्ययन सामग्री, अभ्यास प्रश्न और
              स्कॉलरशिप परीक्षाओं की सुविधा प्रदान करना है, ताकि हर बच्चा शिक्षा के
              क्षेत्र में आगे बढ़ सके।
            </p>
            <p>Eduat10 में पढ़ाई की शुरुआत ₹10 प्रति विषय प्रति माह और ₹100 प्रति विषय प्रति वर्ष से होती है। 5 विषय चुनने पर 1 विषय बिल्कुल FREE मिलता है। <a href="/pricing">कीमत देखें</a></p>
            <p>&nbsp;</p>
            <p>
               EduAt10 is an education-focused digital learning platform created with a
                mission to make quality education affordable and accessible for every
                student, especially those who cannot afford expensive tuition fees or
                costly books.
              
            
                Our platform allows students to study subject-wise topics, practice
                questions, and participate in scholarship exams at a very minimal cost.
                We strongly believe that financial limitations should never stop a child
                from learning and growing.
            </p>
            <p>&nbsp;</p>
            <p>
              "Eduat10 offers affordable learning starting from INR 10 per subject monthly and INR 100 yearly. Select 5 subjects and get 1 subject FREE." <a href="/pricing">View Pricing</a>
            </p>
            <input
              type="email"
              placeholder="Email address"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={inputStyle}
            />

            <div style={{ position: "relative" }}>
              <input
                type={showPwd ? "text" : "password"}
                placeholder="Password"
                required
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
                style={inputStyle}
              />

              <span
                onClick={() => setShowPwd(!showPwd)}
                style={{
                  position: "absolute",
                  right: 12,
                  top: 12,
                  cursor: "pointer",
                  fontSize: 14,
                  color: "#2563eb",
                  fontWeight: 600,
                }}
              >
                {showPwd ? "Hide" : "Show"}
              </span>
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                ...btnStyle,
                background: loading
                  ? "#94a3b8"
                  : "linear-gradient(90deg,#2563eb,#1d4ed8)",
              }}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
          {/* LINKS */}
          <div style={{ marginTop: 14 }}>
            <p style={linkStyle} onClick={() => nav("/register")}>
              Create Account
            </p>
            <p style={linkStyle} onClick={() => nav("/forgot-password")}>
              Forgot Password?
            </p>
          </div>
          

          {/* FOOTER */}
          <div style={footerLinks}>
            <a href="/about-us" style={linkStyle}>About Us</a>
            <span>|</span>
            <a href="/privacy-policy" style={linkStyle}>Privacy Policy</a>
            <span>|</span>
            <a href="/terms-conditions" style={linkStyle}>Terms</a>
            <span>|</span>
            <a href="/contact-us" style={linkStyle}>Contact</a>
            <span>|</span>
            <a href="/pricing" style={linkStyle}>View Pricing</a>
            <span>|</span>
            <a href="/app-preview" style={linkStyle}>App Preview</a>
            <span>|</span>
            <a href="/exam-rules" style={linkStyle}>Read Scholarship Exam Rules & Regulations</a>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ===== STYLES ===== */

const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const overlayStyle = {
  minHeight: "100vh",
  backgroundColor: "rgba(0,0,0,0.25)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const cardWrapper = {
  width: "100%",
  maxWidth: 480,
  textAlign: "center",
  padding: 20,
};

const logoStyle = {
  width: 120,
  marginBottom: 20,
};

const cardStyle = {
  padding: 28,
  background: "rgba(255,255,255,0.96)",
  borderRadius: 16,
  boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
};

const titleStyle = {
  marginBottom: 6,
  color: "#0f172a",
};

const subtitleStyle = {
  marginBottom: 20,
  fontSize: 14,
  color: "#475569",
};

const inputStyle = {
  width: "100%",
  padding: 12,
  borderRadius: 10,
  border: "1px solid #cbd5f5",
  marginBottom: 14,
  fontSize: 14,
};

const btnStyle = {
  width: "100%",
  padding: 12,
  color: "#fff",
  borderRadius: 10,
  border: "none",
  cursor: "pointer",
  fontWeight: 600,
  marginTop: 6,
};

const linkStyle = {
  cursor: "pointer",
  color: "#111827",
  fontSize: 20,
  marginTop: 8,
  textDecoration: "none",
};

const footerLinks = {
  marginTop: 18,
  marginBottom: 18,
  fontSize: 20,
  color: "#111827",
  display: "flex",
  justifyContent: "center",
  gap: 6,
  flexWrap: "wrap",
};
